export function scrollToWithSpacing(element, spacing) {
    if (spacing === void 0) { spacing = 20; }
    var top = element.getBoundingClientRect().top;
    var newScroll = window.scrollY + top - spacing;
    window.scrollTo(0, newScroll);
}
